module.exports = __webpack_public_path__ + "img/37.c9dd7234.jpg";